import { observer } from "mobx-react-lite";
import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import type { ViewComponent } from "@frui.ts/views/dist";
import type ChangeLicensePlateViewModel from "viewModels/callCenter/search/charges/changeLicensePlateViewModel";
import type VehicleRegisterSynchronizationStatus from "entities/vehicleRegisterSynchronizationStatus";
import { vehicleRegisterSynchronizationStatusToVariant } from "entities/vehicleRegisterSynchronizationStatus";
import AlertWithIcon from "views/common/alertWithIcon";
import { emptyValue } from "utils/emptyValue";

const ChangeLicensePlatePreviewView: ViewComponent<ChangeLicensePlateViewModel> = observer(({ vm }) => {
  if (!vm.item) {
    return null;
  }

  const renderValue = (value?: any) => {
    return value ?? emptyValue;
  };
  const renderVehicleRegisterSynchronizationStatus = (value?: VehicleRegisterSynchronizationStatus) => {
    if (!value) {
      return emptyValue;
    }
    const formattedValue = vm.translateVehicleRegisterSynchronizationStatus(value);
    return <strong className={`text-${vehicleRegisterSynchronizationStatusToVariant(value)}`}>{formattedValue}</strong>;
  };

  return (
    <>
      <div className="bg-light mb-4 p-4 rounded">
        <Form.Row>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("oldCountryId")}</Form.Label>
            <div>{renderValue(vm.formatCountry(vm.chargeResponseVehicle.countryId))}</div>
          </Form.Group>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("oldLicensePlate")}</Form.Label>
            <div>{renderValue(vm.chargeResponseVehicle.licensePlate)}</div>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("oldExternalVehicleIdent")}</Form.Label>
            <div>{renderValue(vm.changePreview.vehicleRegisterVehicle?.externalVehicleIdent)}</div>
          </Form.Group>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("oldVin")}</Form.Label>
            <div>{renderValue(vm.changePreview.vehicleRegisterVehicle?.vin)}</div>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("vehicleRegisterSynchronizationStatus")}</Form.Label>
            <div>{renderVehicleRegisterSynchronizationStatus(vm.changePreview.vehicleRegisterSynchronizationStatus)}</div>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("countryId")}</Form.Label>
            <div>{renderValue(vm.formatCountry(vm.changePreview.countryId))}</div>
          </Form.Group>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("licensePlate")}</Form.Label>
            <div>{renderValue(vm.changePreview.licensePlate)}</div>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("externalVehicleIdent")}</Form.Label>
            <div>{renderValue(vm.changePreview.newVehicleRegisterVehicle?.externalVehicleIdent)}</div>
          </Form.Group>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("vin")}</Form.Label>
            <div>{renderValue(vm.changePreview.newVehicleRegisterVehicle?.vin)}</div>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("newVehicleRegisterSynchronizationStatus")}</Form.Label>
            <div>{renderVehicleRegisterSynchronizationStatus(vm.changePreview.newVehicleRegisterSynchronizationStatus)}</div>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("officialRecordId")}</Form.Label>
            <div>{renderValue(vm.changePreview.officialRecordId)}</div>
          </Form.Group>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("emailAddress")}</Form.Label>
            <div>{renderValue(vm.changePreview.emailAddress)}</div>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("orderIdent")}</Form.Label>
            <div>{renderValue(vm.chargeResponse.orderIdent)}</div>
          </Form.Group>
        </Form.Row>
      </div>
      <>
        {vm.rejectedReasonText && <AlertWithIcon variant="danger">{vm.rejectedReasonText}</AlertWithIcon>}
        {vm.warningReasons?.map(reason => (
          <AlertWithIcon key={reason} variant="warning" className="warning-light">
            {vm.translate(`warningReasons.${reason}`).replace("%LICENSE_PLATE%", vm.changePreview?.licensePlate ?? emptyValue)}
          </AlertWithIcon>
        ))}
      </>
    </>
  );
});

export default ChangeLicensePlatePreviewView;
